import { object, string, number, func } from 'prop-types';
import React, { useEffect, useState, memo } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getJdxSession, refreshJdxTimeout } from './../../actions/session';
import { timeoutMs, getJdxUrlFromAction } from './JDXUtils';
import LoadingIndicator from 'ps-components/LoadingIndicator/LoadingIndicator';
import { downloadJobDescription } from '../../components/MarketPricing/MarketPricingActions';

import apiClient from 'ps-components/lib/apiClient';

import './JDXModalIframe.scss';

JDXModalIframe.propTypes = {
  history: object,
  modalProps: object,
  actions: object,
  jdxSessionKey: string,
  jdxSessionTime: number,
  masterAccountId: string,
  jdxUrl: string,
  getJdxSession: func,
  refreshJdxTimeout: func,
  downloadJobDescription: func
};

function JDXModalIframe({
  jdxSessionKey,
  jdxSessionTime,
  masterAccountId,
  jdxUrl,
  getJdxSession,
  refreshJdxTimeout,
  downloadJobDescription,
  history,
  modalProps,
  actions
}) {
  const [JDXValue, setJDXValue] = useState(modalProps.currentJob.code);
  // 'renderIFrame' can be utilized if there is ever a case where JDX does not need a parameter
  // But still needs to render.
  const [renderIframe, setRenderIFrame] = useState(false);
  // timeDiff will indicate how many ms over the timeout its been
  let timeDiff = (jdxSessionTime ? Date.now() - jdxSessionTime : 0) - timeoutMs;
  if (timeDiff < 0) timeDiff = 0;

  useEffect(() => {
    if (jdxSessionKey && !timeDiff) refreshJdxTimeout();
    else if (masterAccountId) getJdxSession(masterAccountId);
  }, [timeDiff]);

  useEffect(() => {
    if (modalProps.currentJob) {
      getJdxJobCode(modalProps.currentJob.code, modalProps.currentJob.codeKey).then(setJDXValue);
      setRenderIFrame(true);
    }
  }, [modalProps.currentJob.code]);

  async function getJdxJobCode(jobCode, jobCodeKey) {
    const result = await apiClient.apiGet(`/api/payscale/jdxpert/getJdxJobCode`, {
      params: {
        jobCode,
        jobCodeKey
      }
    });
    if (result.status === 200) return result.data.udfValue ? result.data.udfValue : jobCode;
  }

  const jdxAction = getJdxUrlFromAction(modalProps.jdxAction, jdxSessionKey, JDXValue);

  function hideModal() {
    history.push(modalProps.backToRoute);
    if (modalProps.currentJob?.id && modalProps.currentJob?.code) {
      downloadJobDescription({ id: modalProps.currentJob.id, code: modalProps.currentJob.code });
    }
    actions.hideModal();
  }

  return (
    <div className="iframe-modal__container" displayCloseButton={true}>
      <div className="iframe-modal__header-container">
        <h2 className="iframe-modal__title-text">{modalProps.titleText}</h2>
        {!modalProps.backToText && (
          <i title="Close Modal" onClick={hideModal} className="icon-cancel iframe-modal__close-modal" />
        )}
        {modalProps.backToText && (
          <a title="Close Modal" onClick={hideModal} className="iframe-modal__close-modal back-to-text">
            Go back to {modalProps.backToText}
          </a>
        )}
      </div>
      <>
        <LoadingIndicator loading={!(jdxSessionKey && renderIframe)} />
        {jdxSessionKey && renderIframe && <PureIframe src={`${jdxUrl}${jdxAction}`} />}
      </>
    </div>
  );
}

const PureIframe = memo(({ src }) => {
  return <iframe src={src} className="iframe-modal__iframe" />;
});
PureIframe.propTypes = { src: string };
PureIframe.displayName = 'PureIframe';

const mapStateToProps = ({ session }) => {
  return {
    jdxSessionKey: session.jdxSessionKey,
    jdxSessionTime: session.jdxSessionTime,
    jdxUrl: session.organization.accountMetaData.hrtmsUrl,
    masterAccountId: session.organization.masterAccountId
  };
};

const actions = { getJdxSession, refreshJdxTimeout, downloadJobDescription };

export default connect(mapStateToProps, actions)(withRouter(JDXModalIframe));
